import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CodeMetadata } from '../../../models';
import { AbstractIdentityConfigService } from '../../abstract-identity-config/abstract-identity-config.service';
import { AbstractService } from '../abstract-http/abstract-service';

@Injectable()
export class CodeService extends AbstractService {
  constructor(http: HttpClient, configService: AbstractIdentityConfigService) {
    super(http, configService);
  }

  getCodeMetadata(code_id: string): Observable<CodeMetadata> {
    return this.http.get<CodeMetadata>(this.buildUrl(({ codeMetadata }) => codeMetadata, { code_id }));
  }
}
